export default __webpack_public_path__ + "static/media/avatar_3@2x.269186b9.png";